import React from "react";

import WhyChooseSection from "../pages/WhyChooseSection";
import ReviewsSection from "../pages/ReviewsSection";

const AboutSection = () => {
  const stats = [
    {
      number: "10K",
      label: "Happy Customers",
    },
    {
      number: "100",
      label: "Vehicles Available",
    },
    {
      number: "10",
      label: "Years Experience",
    },
  ];

  const features = [
    "Safe & Reliable Travel",
    "Experienced Drivers",
    "24×7 Cab Service",
    "Affordable Pricing",
    "Clean & Comfortable Cabs",
    "On-Time Pickup & Drop",
  ];

  return (
    <>
      {/* Page Banner */}
      <section className="page-banner">
        <div className="page-banner-container">
          <h2>About Us</h2>
        </div>
      </section>

     <div className="sai-about-page">
    {/* Page Banner */}
   

    {/* About Section */}
    <section className="sai-about-page__about">
      <div className="sai-about-page__container">
        <div className="sai-about-page__grid">

          <div className="sai-about-page__content">

            <span className="sai-about-page__small-title">
              Who We Are
            </span>

            <h2>
              Sai Shirdi Cabs provides safe, comfortable and
              reliable taxi services for Shirdi and destinations
              across Maharashtra.
            </h2>

            <div className="sai-about-page__inner">

              <div className="sai-about-page__text">

                <p>
                  Sai Shirdi Cabs is a trusted cab service provider
                  offering reliable transportation for devotees,
                  families, tourists and business travellers visiting
                  Shirdi. We provide Shirdi airport transfers,
                  local sightseeing, outstation cabs and one-way
                  and round-trip taxi services.
                </p>

                <p>
                  Whether you are travelling to Shirdi Sai Baba
                  Temple, visiting nearby pilgrimage destinations,
                  or planning an outstation trip, our experienced
                  drivers and comfortable vehicles ensure a safe
                  and hassle-free journey.
                </p>

                <p>
                  We offer a wide range of vehicles including Sedan,
                  Ertiga, SUV, Innova and Innova Crysta. With
                  transparent pricing, clean vehicles and 24×7
                  customer support, Sai Shirdi Cabs is committed to
                  making every journey comfortable and convenient.
                </p>

              </div>

              <div className="sai-about-page__image">
                <img
                  src="/images/about.png"
                  alt="Sai Shirdi Cabs"
                />
              </div>

            </div>
          </div>

        </div>
      </div>
    </section>

    <WhyChooseSection />
    <ReviewsSection />
  </div>

    </>
  );
};

export default AboutSection;
